export default __webpack_public_path__ + "static/vopak-235e2d2e001c7c898d09b60eeb9aa23f.webp";